import { styled } from "styled-components";

const VersionContainer = styled.div`
  height: 20px;
  padding-top: 3px;
  color: #fff;
  font-size: 12px;
  align-self: center;
  margin-left: 4px;
`;

export default VersionContainer;